var map = {
	"./Base": 716,
	"./Base/": 716,
	"./Base/index": 716,
	"./Base/index.js": 716,
	"./Base/style": 171,
	"./Base/style.js": 171,
	"./Clutch": 419,
	"./Clutch/": 419,
	"./Clutch/index": 419,
	"./Clutch/index.js": 419,
	"./Clutch/renderComponent": 1638,
	"./Clutch/renderComponent.js": 1638,
	"./Clutch/style": 1285,
	"./Clutch/style.js": 1285,
	"./NewUi": 1006,
	"./NewUi/": 1006,
	"./NewUi/index": 1006,
	"./NewUi/index.js": 1006,
	"./NewUi/style": 1286,
	"./NewUi/style.js": 1286,
	"./OldUi": 1007,
	"./OldUi/": 1007,
	"./OldUi/index": 1007,
	"./OldUi/index.js": 1007,
	"./OldUi/renderComponent": 1639,
	"./OldUi/renderComponent.js": 1639,
	"./OldUi/style": 1287,
	"./OldUi/style.js": 1287,
	"./SpireonNew": 1008,
	"./SpireonNew/": 1008,
	"./SpireonNew/index": 1008,
	"./SpireonNew/index.js": 1008,
	"./SpireonNew/renderComponent": 1640,
	"./SpireonNew/renderComponent.js": 1640,
	"./SpireonNew/style": 1288,
	"./SpireonNew/style.js": 1288,
	"./SpireonOld": 1009,
	"./SpireonOld/": 1009,
	"./SpireonOld/index": 1009,
	"./SpireonOld/index.js": 1009,
	"./SpireonOld/renderComponent": 1641,
	"./SpireonOld/renderComponent.js": 1641,
	"./SpireonOld/style": 1289,
	"./SpireonOld/style.js": 1289
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;